import React from "react";
import {Card, CardBody} from "reactstrap";

const AccessDenied: React.FC = () => {
  return (
    <>
      <div data-testid="accessDenied" className={"container"}>
        <div className={"row justify-content-center"}>
          <div className={"col-8 col-lg-4 col-md-5"}>
            <Card className={"mt-3"}>
              <CardBody className={"px-6 px-lg-4 px-md-3 py-4 text-center"}>
                <h1
                  className={"fs-9 fs-lg-9 fs-md-8 fs-sm-9 inverted-card-title"}
                >
                  <strong>403</strong>
                </h1>
                <p className={"px-2 text-black"}>
                  <strong>
                    Sorry, you don't currently have access to this page.
                  </strong>
                </p>
                <hr />
                <p className={"px-2"}>
                  Please contact the Service Desk if you think this is a
                  mistake.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
